import * as React from 'react';
import { Operations } from 'Core/Api/Api';
import AuthContext from 'Context/AuthContext';
import Utility from 'Core/Utility';

export interface Props {
  children?: React.ReactNode;
  operations: Operations[];
}

export interface State {
  show: boolean;
}

export default class ShowIfHavePermission extends React.Component<Props, State> {
  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;

  constructor(props: Props) {
    super(props);

    this.state = {
      show: false,
    };
  }

  componentDidMount() {
    const operations = this.props.operations ?? [Operations.Is_Authenticated];
    this.setState({ show: Utility.HasOperations(this.context.data, operations) });
  }

  componentDidUpdate(prevProps: Props) {}

  render() {
    return <>{this.state.show && this.props.children}</>;
  }
}










